import { Box, IconButton, Divider, Stack, Typography } from "@mui/material";
import * as React from "react";
import { useTheme } from "@emotion/react";
import { CollapsableCard } from "./collapsable_card";

export function InfoLine({ name, value, buttonIcon, onButtonClick, width, minWidth }) {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" sx={{ width: width ? width : "100%" }}>
      <Typography
        variant="body2"
        sx={{
          paddingTop: 1,
          paddingBottom: 1,
          minWidth: minWidth || "140px",
          display: "flex",
          userSelect: "none",
          fontWeight: "bold",
          textTransform: "Uppercase",
          color: "#999",
        }}
      >
        {name}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          wordWrap: "break-word",
          paddingTop: 1,
          paddingBottom: 1,
          fontWeight: "bold",
          display: "inline-block",
          flexGrow: 1,
        }}
      >
        {value ? value : "N/A"}
      </Typography>
      {buttonIcon ? (
        <IconButton sx={{ padding: 0, width: "30px", height: "30px" }} onClick={onButtonClick}>
          {buttonIcon}
        </IconButton>
      ) : null}
    </Stack>
  );
}

export default function InfoCard({ content, tooltip, ...props }) {
  return (
    <CollapsableCard tooltip={tooltip} title={"Box Info"} {...props}>
      <Stack direction="column" mx={1} mt={1} mb={1}>
        {content.map((item, index) => (
          <React.Fragment key={item.key}>
            <InfoLine
              name={item.key}
              value={item.value}
              buttonIcon={item.buttonIcon}
              onButtonClick={item.onButtonClick}
              width={"100%"}
            />
            {index < content.length - 1 ? <Divider /> : null}
          </React.Fragment>
        ))}
      </Stack>
    </CollapsableCard>
  );
}
